module.exports = __webpack_public_path__ + "static/media/prostudio.53f94286.svg";